export function updateWebhookV1(send) {
  return (webhookId, body, ...args) =>
    send(
      {
        path: '/v1/webhooks/{webhookId}',
        pathParameters: { webhookId },
        type: 'post',
        query: undefined,
        body: body,
        headers: undefined,
        auth: 'oauth2',
        contentType: 'application/json',
      },
      ...args
    );
}
